
define('views/template/topHeader/index',[
	"text!./template.html",
	"./joinbox/index",
	"ssi!fragment/topnav/index",
	"ssi!fragment/topnav/hideMaps/index",
	"ssi!fragment/topnav/admin/index",
//	"less!./style" This moved to the template.css
], function(template, JoinBoxView, topNavTemplate, topNavTemplatehideMaps, topNavAdmin) {
	
	return Backbone.View.extend({

		initialize: function() {
			
			if(!this.$el.html()) {
				this.render();

				this.options = _.extend({
					justUser: true
				}, this.options);
			}
			
			if(this.options.subheading)
				this.$("h3").html(this.options.subheading);
			
			new JoinBoxView(_.extend(this.options, {el: this.$(".joinbox ul")}));

		},

		render: function() {

			this.$el.html(_.template(template, _.extend(this.options, {
				navTemplate: (this.options.admin ? topNavAdmin : (this.options.hideMaps ? topNavTemplatehideMaps : topNavTemplate))
			})));
			
			if(this.options.admin)
				this.$el.addClass("admin");

		}


	});

});